export interface ContentType {
    uuid: string;
    displayName: string;
    slug: string;
    fields: Field[];
}

export interface Field {
    uuid: string;
    displayName: string;
    slug: string;
    controls: FieldControls;
}

export interface FieldControls {
    fieldType: FieldType;
    displayField: boolean;
    linkUuid?: string;
    settings: {
        selectOptions: string[];
    };
}

export enum FieldType {
    String = 'String',
    Text = 'Text',
    Integer = 'Integer',
    Number = 'Number',
    Boolean = 'Boolean',
    SingleLink = 'SingleLink',
    MultiLink = 'MultiLink',
    Currency = 'Currency',
}
